import { Enrollment } from "views/rent-reporting-onboarding/providers/enrollment/types";

export const getPendingEnrollmentReason = (enrollment: Enrollment) => {
  if (enrollment.reporting_enrollment_status !== "pending")
    return enrollment.reporting_enrollment_status;

  if (
    enrollment.identity_verification_status ===
      "identity_verification_pending" ||
    enrollment.identity_verification_status === "identity_verification_rejected"
  )
    return "identity_verification_pending";

  if (
    enrollment.lease_verification_status === "lease_verification_pending" ||
    enrollment.lease_verification_status === "lease_verification_rejected"
  )
    return "lease_verification_pending";

  if (
    enrollment.landlord_verification_status ===
      "landlord_verification_pending" ||
    enrollment.landlord_verification_status === "landlord_verification_failed"
  )
    return "landlord_verification_pending";

  if (
    enrollment.portal_verification_status === "portal_verification_pending" ||
    enrollment.portal_verification_status === "portal_verification_rejected"
  )
    // We don't ask for this yet, but just in case
    // return "portal_verification_pending";
    return "payment_verification_pending";

  return "payment_verification_pending";
};

export const getPendingReason = (
  reason:
    | ReturnType<typeof getPendingEnrollmentReason>
    | "portal_verification_pending"
) => {
  if (reason === "lease_verification_pending")
    return "Lease verification pending";
  if (reason === "identity_verification_pending")
    return "Identity verification pending";
  if (reason === "landlord_verification_pending")
    return "Landlord verification pending";
  if (reason === "portal_verification_pending")
    return "Portal verification pending";
  if (reason === "payment_verification_pending")
    return "Payment verification pending";
  return "";
};

export const getPendingReasonSubtext = (
  reason:
    | ReturnType<typeof getPendingEnrollmentReason>
    | "portal_verification_pending"
) => {
  if (reason === "lease_verification_pending")
    return "We're verifying your lease details now, we'll notify you if your lease needs to be uploaded";
  return "";
};
